"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var ListModuleForm_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListModuleForm = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const merge_1 = __importDefault(require("lodash/merge"));
const backoffice_1 = require("../../dsl/backoffice");
const form_1 = require("../_abstract/form");
const form_2 = require("../_components/form");
const _contracts_1 = require("../_contracts");
const ListItemForm_1 = require("./_partials/ListItemForm");
/**
 * TODO:
 *   - Fix order of properties/methods/getters/setters.
 *   - Add missing JSDoc blocks.
 *
 * Component that contains a complete questionnaire needed to **EDIT** the `ListModule`'s contents.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 */
let ListModuleForm = ListModuleForm_1 = class ListModuleForm extends form_1.AbstractModuleForm {
    constructor() {
        super(...arguments);
        this.DashmixIconName = backoffice_1.DashmixIconName;
        /**
         * @inheritDoc
         * @override
         */
        this.initialContent = ListModuleForm_1.getInitialContent();
        this.item = {
            children: [],
            meta: { isLoose: false, isOrdered: false, start: '' },
            text: ''
        };
    }
    /**
     * @inheritDoc
     * @override
     */
    static getInitialConfig() {
        return {
            driver: _contracts_1.ModuleDriver.List,
            size: {
                colSpan: 2,
                rowSpan: 1,
                isResizable: true,
                minColSpan: 1,
                minRowSpan: 1,
                maxColSpan: 6
            }
        };
    }
    /**
     * @inheritDoc
     * @override
     */
    static getInitialContent() {
        return {
            items: [],
            meta: { isLoose: false, isOrdered: false, start: '' }
        };
    }
    get hasItems() {
        if (!this._content.items) {
            return false;
        }
        return this._content.items.length > 0;
    }
    get isOrdered() {
        return this._content.meta.isOrdered;
    }
    set isOrdered(value) {
        this._content.meta.isOrdered = value;
    }
    addChild() {
        this._content.items.push(JSON.parse(JSON.stringify(this.item)));
    }
    deleteItem(index) {
        const itemCopy = [...this._content.items];
        itemCopy.splice(index, 1);
        this._content.items = itemCopy;
    }
    updateItem(index, newItemChildren) {
        const itemCopy = [...this._content.items];
        itemCopy[index] = newItemChildren;
        this._content.items = itemCopy;
    }
    /**
     * @inheritDoc
     * @override
     */
    setInitialContent() {
        const content = merge_1.default(this.initialContent, this._content);
        if (content.items.length === 0) {
            content.items.push(JSON.parse(JSON.stringify(this.item)));
        }
        this._content = content;
    }
};
ListModuleForm = ListModuleForm_1 = __decorate([
    vue_property_decorator_1.Component({
        name: 'ListModuleForm',
        components: {
            DashmixButton: backoffice_1.DashmixButton,
            DashmixCheck: backoffice_1.DashmixCheck,
            DashmixInput: backoffice_1.DashmixInput,
            ListItemForm: ListItemForm_1.ListItemForm,
            FormErrors: form_2.FormErrors
        },
        template: `
    <div  class="list-form">
      <!-- Main meta -->
        <div>
          <DashmixCheck v-if="hasItems"
                        class="pb-2"
                        :model.sync="isOrdered"
                        name="meta-isOrdered" :label="$t('forms.list.isOrdered')" />
        </div>

        <ul v-if="hasItems" class="m-0 p-0 list-unstyled">
          <ListItemForm v-for="(item, index) in _content.items"
                        :key="index"
                        bgClass="bg-gray-lighter"
                        :isOrdered="isOrdered"
                        :treeLevel="1"
                        :item="item" :index="index" @updateItem="updateItem" @deleteItem="deleteItem" />
        </ul>

        <DashmixButton :label="$t('forms.list.addChild')" @click="addChild"
                       :icon="DashmixIconName.PlusSolid" variant="icon" />

      <!-- Form errors -->
      <FormErrors v-if="errors" v-bind="{ errors }" class="mt-3" />
    </div>`
    })
], ListModuleForm);
exports.ListModuleForm = ListModuleForm;
//# sourceMappingURL=List.form.js.map